import _ from 'lodash'

export default ({
  recipients,
  ...rest
}) => ({
  recipients: _.map(recipients, (r) => _.pick(r, 'email')),
  ...rest
})
